export default __webpack_public_path__ + "static/media/logo.c6c8ee91.png";